import { enumify } from '../lib/typeInference.js';
import { IPerkPoints, IPerkVisualisation, IPointPerk } from './perk.types.js';

export const loyaltyProviderValues = [
    'PEPPER',
    'SQUARE',
    'POWERCARD',
    'ATREEMO',
    'REVEL',
    'PAYTRONIX',
    // Comtrex is not an external provider, but a pseudo loyalty provider to handle loyalty-at-POS related tasks such as
    // redemptions and earning. We create and control the shortIds for both users and awards through the ComtrexLoyaltyService class.
    'COMTREX'
] as const;

export type LoyaltyProvider = (typeof loyaltyProviderValues)[number];
export const LoyaltyProviderEnum = enumify(loyaltyProviderValues);

// the fields needed for awards function ie track award points;
export type IPointAwardCore<IDTYPE> = {
    _id: IDTYPE;
    tenantId: IDTYPE;
    loyaltyProvider: LoyaltyProvider;
    perkId: IDTYPE;
    userId: IDTYPE;
    points: IPerkPoints & { available: number };

    updatedAt: Date;
    shortId?: string; // shortId is used internally for Comtrex loyalty-at-POS
    expiry?: Date; // FIXME mapped from date time restriction - do we need this?
};
// the fields that are award specific and not duplicated in the perk
// FIXME expiry mapped from date time restriction - do we need this?
export const awardCoreFields = ['_id', 'perkId', 'userId', 'points', 'updatedAt', 'tenantId', 'loyaltyProvider', 'shortId', 'expiry'] as const;

// FIXME should perk.enabled be included? current award excludes it
export type IPointAward<IDTYPE> = Omit<IPointPerk<IDTYPE>, '_id' | 'points' | 'enabled' | 'tenantId'> & IPointAwardCore<IDTYPE>;

// For creating POS Loyalty compatible external awards, _id and perkId are strings, and visualisation is optional
// _id is always returned as a string regardless
export type IPointAwardExternal<IDTYPE> = Omit<IPointAward<IDTYPE>, '_id' | 'perkId' | 'visualisation' | 'shortId'> & {
    _id: string;
    perkId: string;
    visualisation?: IPerkVisualisation;
};

// points should say what happens when getting award and redeeming
